export default __webpack_public_path__ + "static/media/Up.ba73aa42.svg";